export default {
  all: "Todos",
  search: "Buscar",
  refresh: "Actualizar",
  retry: "Reintentar",
  loading: "Cargando...",
  page: "Página",
  of: "de",
  back: "Volver",
  language: "Idioma",
  deleteConfirmation: "¿Estás seguro de que quieres eliminar este elemento?",
  saveDraft: "Guardar borrador",
  saveAndPublish: "Guardar y publicar",
  remove: "Eliminar",
  edit: "Editar",
  delete: "Eliminar",
  shared: {
    appLogoAlt: "WAW Travel Logo",
    agency: "Agencia",
    user: "Usuario",
    client: "Cliente",
    collaborator: "colaborador",
    admin: "Administrador",
    location: "Ubicación",
    resource: "Recurso",
    contact: "Contacto",
    supplier: "Proveedor",
    case: "Caso",
    search: "Buscar",
    name: "Nombre",
    legalName: "Razón Social",
    surname: "Apellidos",
    nameAndSurname: "Nombre y Apellidos",
    loginEmail: "Email de Login",
    email: "Correo electrónico",
    password: "Contraseña",
    passwordConfirmation: "Confirmación de contraseña",
    filters: "Filtros",
    cannotUndo: "Esta operación no se puede deshacer",
    noLocation: "Sin ubicación",
    writeSearchAgencies: "Escribir para buscar agencias",
    writeSearchUsers: "Escribir para buscar usuarios",
    pagination: "Paginación",
    tableShowNumber: "Mostrar: {number}",
    tableShowing: "Mostrando {from} a {to} de {total}",
    archived: "Archivado",
    active: "Activo",
    actions: "Acciones",
    orCreateNew: "o crear nuevo",
    archive: "Archivar",
    restore: "Restaurar",
    delete: "Eliminar",
    type: "Tipo",
    types: "Tipos",
    title: "Título",
    created: "Creado",
    description: "Descripción",
    writeItManually: "o puedes escribirlo manualmente",
    links: "Enlaces",
    map: "Mapa",
    uploadMedia: "Cargar medios",
    source: "Fuente",
    media: "Medios",
    documentType: "Tipo de documento",
    documentNumber: "Número de documento",
    nationality: "Nacionalidad",
    language: "Lengua",
    genre: "Género",
    dateBirth: "Fecha de nacimiento",
    phone: "Teléfono",
    web: "Web",
    website: "Sitio web",
    note: "Nota",
    tag: "Etiqueta",
    countryCode: "Código de país",
    filterSearch: "Búsqueda: '{value}'",
    filterSource: "Origen: '{value}'",
    filterType: "Tipo: '{value}'",
    filterTypes: "Tipos: '{value}'",
    filterAmenity: "Servicios: '{value}'",
    filterLocation: "Localidad: '{value}'",
    filterSurname: "Apellido: '{value}'",
    all: "Todos",
    dateBirthCannotFuture: "Fecha de nacimiento no puede ser en el futuro",
    basicInformation: "Información básica",
    contactInformation: "Información de contacto",
    countryCodePlaceholder: "País (+000)",
    pax: "Pasajeros",
    paxes: "Pasajeros",
    age: "Edad",
    room: "Habitación",
    rooms: "Habitaciones",
    hotels: "Hoteles",
    confirm: "Confirmar",
    dateRange: "Rango de fechas",
    initDate: "Fecha inicial",
    endDate: "Fecha final",
    writeSearchLocations: "Escribe para buscar ubicaciones",
    origin: "Origen",
    destination: "Destino",
    isStage: "Marcar información de etapa",
    isGeneral: "Marcar información general",
    dates: "Fechas",
    cancellationPolicy: "Política de cancelación",
    notes: "Notas",
    paymentMethod: "Forma de pago",
    accountNumber: "Número de cuenta",
    holdedAccountNumber: "Número de cuenta de Holded",
    holdedAccountNumberFormat: "El número de cuenta de Holded debe tener 8 dígitos y empezar por 4000 (ej. 40000001)",
    holdedAccountNumberHint: "Busca o crea una cuenta de Holded",
    holdedAccountSearchHint: "Escribe para buscar cuentas de Holded existentes",
    creatingAccount: "Creando cuenta...",
    createHoldedAccount: "Crear cuenta \"{name}\"{number}",
    holdedAccountCreated: "Cuenta de Holded {number} creada",
    holdedAccountNameRequired: "Introduce el nombre del proveedor antes de crear una cuenta de Holded",
    amenities: "Servicios",
    distanceKm: "Distancia (Km)",
    products: "Productos",
    checkIn: "Entrada",
    checkOut: "Salida",
    priceRange: "Rango de precios",
    veryCheap: "Muy barato",
    cheap: "Barato",
    normal: "Normal",
    expensive: "Caro",
    category: "Categoría",
    price: "Precio",
    searchByNameOrLocation: "Buscar por nombre o ubicación",
    selected: "Seleccionado",
    amount: "Importe",
    invoiceStatus: "Estado de la factura",
    paymentStatus: "Estado del pago",
    noEndDate: "Sin fecha final",
    moreData: "Más datos",
    secondSurname: "Segundo apellido",
    selectOriginMessage: "Debe buscar y seleccionar una ciudad de origen",
    selectDestinationMessage: "Debe buscar y seleccionar una ciudad de destino",
    accommodation: "Alojamiento",
    kilometersShorted: "Km",
    date: "Fecha",
    size: "Tamaño",
    status: "Estado",
    filterStatus: "Estado: '{value}'",
    filterInitDate: "Fecha de inicio desde: '{value}'",
    filterEndDate: "Fecha de finalización hasta: '{value}'",
    filterTravelType: "Tipo de viaje: '{value}'",
    filterModality: "Modalidad: '{value}'",
    filterCmsStatus: "CMS: '{value}'",
    filterTotalDays: "Total de días: '{value}'",
    cmsStatus: "CMS",
    cmsStatusNone: "Sin CMS",
    filterPaxNumber: "Pax: '{value}'",
    filterClient: "Cliente: '{value}'",
    filterReservationStatus: "Estado de la reserva: '{value}'",
    filterPaymentsStatus: "Estado del pago: '{value}'",
    filterInvoicesStatus: "Estado de las facturas: '{value}'",
    filterDestination: "Destino: '{value}'",
    filterOrigin: "Origen: '{value}'",
    filterName: "Nombre: '{value}'",
    reservationStatus: "Estado de la reserva",
    reservations: "Reservas",
    paymentsStatus: "Estado de los pagos",
    payments: "Pagos",
    invoicesStatus: "Estado de las facturas",
    invoices: "Facturas",
    travelType: "Tipo de viaje",
    information: "Localidad",
    paxNumber: "Pasajeros: {value}",
    originAndDestination: "Origen y destino",
    caseManager: "Responsable del caso",
    url: "Url",
    writeSearchProducts: "Escribir para buscar actividades",
    number: "Número",
    euroShort: "€",
    product: "Actividad",
    totalDays: "Total de días",
    sendEmailNotification: "Enviar notificaciones por correo electrónico",
    notificationsSentMail: "Las notificaciones se envían al correo",
    notNotificationsSentMail: "No se envían notificaciones al correo",
    googleMaps: "Google Maps",
    viewWebsite: "Ver sitio web",
    viewGoogleMaps: "Ver en Google Maps",
    filterManager: "Responsable: '{value}'",
    year: "Año",
    filterYear: "Año: '{value}'",
    seenOnlyCasesOnWay: "Ver solo casos en curso",

    country: "País",
    filterOnlyOnWay: "Ver sólo los casos en curso",
    filterStartingSoon: "Inicio de casos hasta '{value}' días",
    filterCaseStartingInDays: "Inicio de casos en '{value}' días",
    filterHotelPaidUntil: "Hotel pagado hasta '{value}' días",
    startingSoon: "Inicio de casos desde hoy hasta",
    oneWeek: "Una semana",
    twoWeeks: "Dos semanas",
    oneMonth: "Un mes",
    daysNumber: "Número de días",
    code: "Código",
    supplier_observations: "Observaciones del proveedor",
    payment_link: "Enlace de pago",
    paymentBy: "Cuando pagar",
    client_observations: "Observaciones de la clienta",
    savedChanges: "Cambios guardados",
    nif: "NIF",
    vat: "VAT",
    preferredLanguage: "Lenguaje preferente",
    bookingType: "Tipo de reserva",
    supplierPortal: "Portal",
    promoCode: "Código promocional",
    other: "Reservando por",
    byEmail: "Reserva por correo electrónico",
    bookingBy: "Reserva por",
    bookingTypeNotFound: "Ningún tipo de Reserva",
    typesOfBooking: "Tipos de reserva",
    bookingOptions: "Opciones de reserva",
    bookings: "Reservaciones",
    persons: "Personas",
    tripManager: "Gestor de viaje",
    offers: "Ofertas",
    initHour: "Hora de inicio",
    endHour: "Hora de fin",
    optional: "opcional",
    nReserve: "Número de reserva",
    flightNumber: "Número de vuelo",
    optionalQuoteItem: "Recurso opcional",
    netValidated: "Precio Validado",
    isValidated: "Tarifas Validadas",
    paid: "Pagado",
    pending: "Pendiente",
    errorMessage: "Ha ocurrido un error",
    files: "Archivos",
    writeCity: "Escribe la ciudad",
    canSearchSupplier: "Puedes buscar el proveedor (opcional)",
    canSearchResource: "Puedes buscar el recurso (opcional)",
    supplierAlreadyExists: "Ya existe un proveedor con el mismo nombre.",
    day: "Día",
    notification: "Notificación",
    supplierNotFound: "Proveedor eliminado",
    markedPay: "Marcar para pagar",
    payAmount: "Cantidad a pagar",
    pendingAmount: "Monto pendiente",
    paidAmount: "Monto de pago",
    hotelName: "Nombre del hotel",
    total: "Total",
    generateXml: "Generar XML",
    priceSummary: "Resumen de precios",
    preview: "XML de pago",
    noDataAvailable: "Datos no disponibles.",
    withoutSupplier: "Sin proveedor",
    quantityShort: "Cantidad",
    paymentMethodOpt: "El proveedor ha optado por",
    supplierAccountNotFound: "Sin cuenta bancaria",
    noPaymentMethod: "No se ha seleccionado ningún método de pago",
    general_information: "General",
    stage_information: "Etapa",
    point_of_interest: "PDI",
    confirmationOfPricing: "Confirmación de reserva y precios",
    confirmPriceInfo: "Por favor introduce el precio neto que WAW TRAVEL tiene que pagarte. Si quieres ofrecernos algo diferente puedes hacerlo en el botón Modificar",
    headerTile: "¿Cuál es el precio de cada servicio? ¿quieres ofrecer algo diferente?",
    unit: "Unidad",
    editPrice: "Editar Precio",
    editPriceWarning: "Aquí puedes introducir el precio de cada servicio",
    editFreeTextWarning: "Aquí puedes ofrecernos algo diferente",
    companyName: "Nombre de la empresa",
    totalCases: "Total de casos",
    completedCases: "Casos completados",
    pendingCases: "Casos pendientes",
    yearsOld: "años",
    startDate:"Fecha de inicio",
    alternativeStartDate:"Fecha de inicio alternativa",
    clientDriveUrl:"Url del caso",
    clientCode:"Código del cliente",
    googleDriveUrl: "URL de Google Drive",
    invalidUrl: "URL inválida",
    clientName: "Nombre del cliente",
    clientEmail: "Correo electrónico del cliente",
    languagePreferedByClient:"Idioma preferido por la cliente",
    clientPhoneNumber:"Número de teléfono del cliente",
    modification: "Modificar",
    supplierList: "Lista de proveedores",
    transfer: "Transferencia",
    transport: "Transporte",
    showSuppliers: "Mostrar proveedores",
    confirmationText: "Estás segura de que quieres { title } este caso?",
    invoice: "Factura",
    concept: "Concepto",
    remainingAmount: "Restante",
    billing: "Facturación",
    customNotes: "Nota personalizada",
    inVoiceTypes: "Tipo de factura",
    totalTrip: "Viaje total",
    totalInvoice: "Total de la factura",
    remaining: "Restante",
    flights: "Vuelos",
    tickets: "Tickets",
    ppu: "Precio por unidad",
    totalFlight: "Total del vuelo",
    serviceFee: "Tarifa del servicio",
    selectFlight: "Seleccionar vuelos",
    inVoiceRecived: "Factura a recibir vía",
    card: "Tarjeta de crédito",
    extracharge: "Cargo extra (en porcentaje)",
    items: 'Elementos',
    various: "Varias",
    noProductsAdded: "No hay productos añadidos",
    syncPax: "Sincronizar pasajero",
    syncPaxMessage: "Sincronizar pasajero correctamente",
    copypax: "Copiar pasajero del día anterior",
    copyPaxMessage: "Copiar pasajero del día anterior correctamente",
    addressStreet: "Dirección",
    addressCity: "Ciudad",
    addressPostalCode: "Código postal",
    addressState: "Provincia / Estado",
    addressCountry: "País",
    birthDate: "Fecha de nacimiento",
    allergies: "Alergias",
    diet: "Dieta",
    height: "Altura",
    weight: "Peso",
    holdedId: "Celebración del Eid",
    arrival: "Llegada",
    arrivalLocation: "Lugar de llegada",
    arrivalNumber: "Número de llegada",
    arrivalType: "Tipo de llegada",
    departure: "Salida",
    departureLocation: "Lugar de salida",
    departureNumber: "Número de salida",
    departureType: "Tipo de salida",
    bikeType: "Tipo de moto",
    month: "Mes",
    back: "Volver",
    saveDraft: "Guardar borrador",
    saveAndPublish: "Guardar y publicar",
    remove: "Eliminar",
    stars: "Estrellas",
    published: "¿Publicado?"
  },
  button: {
    new: "Nuevo",
    close: "Cerrar",
    loading: "Cargando...",
    create: "Crear",
    save: "Guardar",
    book: "Reservar",
    bookNow: "Reservar ahora",
    getAQuote: "Consigue una cotización",
    saving: "Guardando...",
    archive: "Archivar",
    archiving: "Archivando...",
    delete: "Borrar",
    deleting: "Borrar...",
    remove: "Eliminar",
    removing: "Eliminar...",
    confirm: "Confirmar",
    modify: "Modificar",
    cancel: "Cancelar",
    processing: "Procesando",
    add: "Añadir",
    adding: "Añadiendo...",
    forgiveAccess: "Perdonar acceso",
    forgivingAccess: "Perdonar acceso...",
    login: "Iniciar sesión",
    loggingIn: "Iniciar sesión...",
    restore: "Restaurar",
    restoring: "Restaurando...",
    seeAll: "Ver todos",
    next: "Siguiente",
    update: "Actualizar",
    sendEmail: "Enviar email",
    send: "Enviar",
    sending: "Enviando...",
    see: "Ver",
    selectAll: "Seleccionar todos",
    unselectAll: "Deseleccionar todos",
    select: "Seleccionar",
    previous: "Anterior",
    page: "Página",
    of: "de",
    download: "Descargar",
    seeFiles: "Ver archivos",
    generatingPdf: "Generando PDF...",
    seeDay: "Ver día",
    view: "Ver",
    viewMore: "Ver más",
    viewLess: "Ver menos",
    yes: "Sí",
    no: "No",
    ok: "De acuerdo",
    exportBookings: "Exportar reservas",
    published: "¿Publicado?",
    confirmSelection: "Confirmar Selección",
  },
  toast: {
    successMessage: "Mensaje de éxito",
    informationMessage: "Mensaje de información",
    adventMessage: "Mensaje de advenimiento",
    errorMessage: "Mensaje de error",
    otherTypeTooltipMessage: "Por favor detalla cualquier requisito especial o preferencia de habitación que tengas",
    exportTooltip: "Haga clic aquí para exportar sus reservas a la hoja de Google",
    showSupplierBookings: "Haga clic aquí para mostrar las reservas del proveedor",
  },
  roles: {
    super_admin: "Super Administrador",
    admin: "Administrador",
    user: "Usuario",
    agency: "Agencia",
    collaborator: "Colaborador",
    supplier: "Proveedor",
  },
  menu: {
    impersonateStopText: "Volver como Administrador",
    impersonateText: "Has iniciado sesión como el usuario { user } ({ email }).",
    cases: "Casos",
    clients: "Clientes",
    suppliers: "Proveedores",
    resources: "Recursos",
    contacts: "Contactos",
    agencies: "Agencias",
    statistics: "Estadísticas",
    logout: "Cerrar sesión",
    myProfile: "Mi perfil",
    products: "Actividades",
    cms: "CMS",
  },
  adminMenu: {
    paxs: "Pasajeros",
    users: "Usuarios",
    agencies: "Agencias",
    collaborators: "Colaboradores",
  },
  address: {
    address: "Dirección",
    addAddress: "Añadir dirección",
    addressLine2: "Línea de dirección 2",
    billingAddress: "Dirección de facturación",
    aptSuit: "Apto, Suite, Unidad, etc",
    secondAddress: "Segunda dirección",
    city: "Ciudad",
    state: "Estado",
    country: "País",
    postalCode: "Código Postal",
    provinceStateRegion: "Provincia / Estado / Región",
    streetAddress: "Dirección",
    number: "Número",
    matchesContactAddress: "Coincide con la dirección de contacto",
  },
  screenVerify: {
    title: "Lo sentimos",
    message: "El constructo del Tour no está disponible en la versión móvil",
    openOnDesktop: "Para una mejor experiencia, recomendamos acceder desde un dispositivo con la pantalla más grande.",
  },
  vueSelect: {
    noOptions: "Lo sentimos, no hay opciones que coincidan.",
  },
  errors: {
    error404: "404",
    pageNotFound: "¡Ups! Página no encontrada",
    pageNotFoundText: "No podemos encontrar la página que busca.",
  },
  pages: {
    confirmingReservation: "Se está confirmando la reserva...",
    modifingReservation: "Se esta modificando la reserva...",
    reservationConfirmed: "Reserva confirmada!",
    reservationModified: "Reserva modificada!",
    confirmEmailStatus: "Gracias por tu respuesta Recibirás un correo eléctronico",
    modifiedStatus: "Gracias por la sugerencia. Nos pondremos en contacto contigo.",
    emailConfirmationSucess: "Gracias...",
    emailAlreadyUpdated: "Este correo electrónico ya fue actualizado por el proveedor. Si tienes alguna consulta, por favor contactanos.",
  },
  payment: {
    paymentMethod: "Método de pago",
    payViaHolded: "Enviar a Holded",
    payViaWise: "Pagar con Wise",
  },
  invoice: {
    types: {
      "30": "30% del viaje",
      "30-flights": "30% del viaje + vuelos",
      "flights": "Vuelos del viaje",
      "remaining": "Resto del viaje",
      "70": "70% del viaje",
      "100": "100% del viaje",
      "services-info": "Información de servicios del viaje",
      "free-text": "Texto libre del viaje"
    },
    "remaining_amount_trip": "Importe restante del viaje",
    "remaining_amount": "Importe restante",
    "remaining_amount_due": "Importe restante",
    "due_amount": " a pagar 1 mes antes",
  },
  soldPre: "Este pre-caso ha sido vendido.",
  soldVersion: "Otra versión de este pre-caso ha sido vendida.",
  soldLink: "Este es el caso",
  originated: "Originado desde: ",
  paxDetails: "Detalles de pasajeros"
};
